import React from 'react'

import { Form, Col } from '_zari/core'

const CodigoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='CÓDIGO' htmlFor='input-codigo' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.InputText id='input-codigo' name='input-codigo' value={iValue} disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoFormGroup)
